///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { round } from "./laneCalculations";

const gcd = (a, b) => {
  if (!b) {
    return a;
  }

  return gcd(b, a % b);
};

const getInboundOutboundRatio = (inbound, outbound) => {
  let fraction = round(inbound / outbound);

  let denominator = 100;
  let numerator = round(fraction * denominator);

  let divisor = gcd(numerator, denominator);

  numerator /= divisor;
  denominator /= divisor;

  return `${numerator > 100 ? "100+" : numerator}:${
    denominator > 100 ? "100+" : denominator
  }`;
};

export default getInboundOutboundRatio;
